import { QueryKeys, useEntity } from "@/api/core";
import { useLoggedIn } from "@/hooks";
import { type GroupRelationship, groupRelationshipSchema } from "@/schemas";

function useGroupRelationship(groupId: string | undefined) {
  const { isLoggedIn } = useLoggedIn();

  const { entity: groupRelationship, ...result } = useEntity<GroupRelationship>(
    {
      id: groupId!,
      queryKey: QueryKeys.groupRelationships.byGroup(groupId!),
      endpoint: `/api/v1/groups/relationships?id[]=${groupId}`,
      schema: groupRelationshipSchema,
      enabled: !!groupId && isLoggedIn,
    },
  );

  return {
    groupRelationship,
    ...result,
  };
}

export { useGroupRelationship };
